import { combineReducers } from 'redux';

import gymStudioUiReducer from './gymStudioUiReducer';
import gymStudioDataReducer from './gymStudioDataReducer';

export default combineReducers({
  ui: gymStudioUiReducer,
  data: gymStudioDataReducer,
});
